import React, {PureComponent, ReactNode} from 'react';
import {goToMyHero} from 'app/utils/app_links';
import I18n from 'app/i18n';
import ConvertButton from 'app/components/my_profile/artifacts/artifact_popup/compendium/ConvertButton';
import {Provider} from 'mobx-react';
import {promoActionStore} from 'app/store/global';
import {isGuest} from 'app/utils';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface Props {
    prediction_points: number
    loaded: boolean
}

class ConversionCard extends PureComponent<Props> {
    render(): ReactNode {
        const {
            loaded,
            prediction_points
        } = this.props;

        if (!promoActionStore.promoAction) {
            return null;
        }

        return <div className="predictions-top-box">
            <div className="predictions-top-box-description">
                <SpriteIcon name="#svg-scatter-graph" className="icon" size={{height: 27, width: 27}}/>
                <p>{I18n.t('scatter.you_can')}</p>
            </div>
            <div className="compendium-top-box-button">
                <Provider promoActionStore={promoActionStore}>
                    <ConvertButton onClickHandler={goToMyHero}/>
                </Provider>
                {!isGuest() && !loaded && <span className={`prediction-points${prediction_points === 0 ? ' expects-points' : ''}`}>
                    {I18n.t('table.points_title')}: <b>{prediction_points}</b></span>}
            </div>
        </div>;
    }
}

export default ConversionCard;
